import {HomepageHeaderArenaMenuItemDefaultBox} from "./home-page-header-arena-menu-item.default.box";
import { styledByTheme } from "../../../../../themes/architecture/styled-by-theme";
import {HomepageHeaderArenaMenuItemMrGreenBox} from "./home-page-header-arena-menu-item.mrgreen.box";

export const HomepageHeaderArenaMenuItemBox = styledByTheme(HomepageHeaderArenaMenuItemDefaultBox)
    .forMrGreen(HomepageHeaderArenaMenuItemMrGreenBox)
    .apply();
